





















































































































































































































































































































































































































































































































import { localISO, localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import Service from "@/services/RiwayatPerkawinanRalan";
import Store from "@/store/modules/RiwayatPerkawinanRalanStore";
import { storePasien } from "@/store/modules/pasien";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  },
  components: { CardModalTtd }
})
export default class CardRiwayatPerkawinanRalan extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: null }) value: any;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;
  editMode = false;
  editId: number | null = null;

  examinedAt = "";
  openPanels: number[] = [];
  modalTtd = false;
  signRole = "";

  form = this.defaultForm();
  detailForm = this.defaultDetail();
  pasanganForm = this.defaultPasangan();
  riwayatPrev: any[] = [];
  konsangForm = this.defaultKonsang();
  reproForm = this.defaultRepro();
  kbForm = this.defaultKb();
  psikoForm = this.defaultPsiko();
  kdrtForm = this.defaultKdrt();
  kesanForm = this.defaultKesan();

  pemicuItems = [
    { text: "Auto — Poli pemicu (Obgin/Andrologi/Jiwa/dll.)", value: "auto-poli" },
    { text: "Manual — DPJP", value: "manual-dpjp" }
  ];
  sumberVerifikasiItems = ["Buku Nikah", "Akta Cerai", "Surat Kematian Pasangan", "Pernyataan Lisan"];
  pendidikanItems = ["Tidak sekolah", "SD", "SMP", "SMA/SMK", "Diploma", "S1", "S2", "S3"];
  agamaItems = ["Islam", "Kristen Protestan", "Katolik", "Hindu", "Buddha", "Konghucu", "Penghayat Kepercayaan"];
  frekuensiKdrt = ["Tidak pernah", "Jarang", "Kadang", "Sering", "Sangat sering"];

  defaultForm() {
    return {
      status_kmk: null,
      tanggal_pernyataan_status: this.todayDate,
      sumber_verifikasi_status: null,
      status_faktual: null,
      tanggal_pernikahan: null,
      usia_saat_menikah: null,
      pernikahan_ke: null,
      konsanguinitas_ada: null,
      konsanguinitas_derajat: null,
      kdrt_wawancara_pribadi: false,
      kdrt_instrumen: null,
      kdrt_skor_total: null,
      kdrt_interpretasi: null,
      kdrt_aman_di_rumah: null,
      ringkasan: null,
      pemicu: "manual-dpjp"
    };
  }
  defaultDetail() { return { bentuk_pencatatan: null, tempat_pernikahan: null, tgl_perceraian: null, pihak_pengaju: null, alasan_perceraian: null, tgl_meninggal_pasangan: null, sebab_kematian_pasangan: null }; }
  defaultPasangan() { return { calon: false, nama: null, nik: null, tgl_lahir: null, jk: null, pekerjaan: null, pendidikan: null, agama: null, suku: null, kesehatan: null, faktor_risiko: [], tinggal_bersama: null }; }
  defaultKonsang() { return { F: null, kelainan_kongenital: [], etnis_pasien: null, etnis_pasangan: null, rekomendasi_konseling: null }; }
  defaultRepro() {
    return {
      gravida: null, paritas: null, abortus: null, anak_hidup: null, anak_meninggal: null,
      infertilitas: null, lama_berusaha_hamil: null,
      menarche: null, hpht: null, siklus_haid: null, menopause: null,
      anak_biologis: null, pernah_hamilkan: null, disfungsi_seksual: null, operasi_genital: null,
      seksualitas: { aktif: null, dispareunia: null, ims: null }
    };
  }
  defaultKb() { return { status_pemakaian: null, metode: [], mulai: null, sumber: null, efek_samping: null, rencana: null, rencana_anak: null, jml_anak_diinginkan: null }; }
  defaultPsiko() { return { kualitas: null, sumber_dukungan: [], konflik_berulang: null, topik_konflik: [], konseling: null, beban_pengasuhan: null, perpisahan: null }; }
  defaultKdrt() { return { fisik: null, psikis: null, seksual: null, ekonomi: null, pernah_lapor: null, rtl: null }; }
  defaultKesan() { return { temuan: [], diagnosis: [], rtl: [], edukasi: null }; }

  get todayDate() {
    return localISODate();
  }
  get stateuser() { return userModule.user; }

  get isFemale() {
    // Gunakan storePasien.identitasPasien.jk ("P" → perempuan). Bila data
    // belum tersedia, default ke true agar field Obgin tetap muncul (bisa
    // diabaikan untuk pasien laki-laki).
    const jk = storePasien.identitasPasien?.jk;
    if (jk === "L") return false;
    return true;
  }

  get isPraNikah() {
    // Toggle manual via section pasangan ("Calon pasangan"): bila status_kmk
    // = Belum Kawin tetapi DPJP ingin mendokumentasikan calon pasangan
    // (Poli Pra-nikah, premarital screening) — checkbox di Section 6 jadi
    // tampil dengan menandai status_kmk = 1 + checkbox "calon".
    return this.form.status_kmk === 1;
  }

  get isCalonPasangan() { return this.pasanganForm.calon === true; }

  get showDetail() { return this.form.status_kmk === 2 || this.form.status_kmk === 3 || this.form.status_kmk === 4; }
  get showPasangan() { return this.form.status_kmk === 2 || (this.form.status_kmk === 1 && this.isPraNikah); }
  get showRiwayatPrev() { return (this.form.pernikahan_ke || 0) > 1 || this.form.status_kmk === 3 || this.form.status_kmk === 4; }

  get usiaAlert() {
    if (this.form.usia_saat_menikah !== null && this.form.usia_saat_menikah !== undefined && this.form.usia_saat_menikah < 19) {
      return ["⚠ Di bawah batas UU 16/2019 — catat justifikasi (dispensasi pengadilan) di bagian Kesan & Implikasi Klinis"];
    }
    return [];
  }

  get isFullySigned() { return this.value && this.value.signed_dpjp && (this.value.perawat_user_id ? this.value.signed_perawat : true); }
  get canEdit() {
    if (!this.value) return false;
    const uid = userModule.user.id;
    return uid === this.value.creator_user_id || uid === this.value.perawat_user_id || uid === this.value.dpjp_user_id;
  }
  get bisaHapus(): boolean {
    if (!this.value || this.readOnly || !this.canEdit) return false;
    return !alasanTtdMengunciHapus(
      this.value.creator_user_id,
      [
        { ditandatangani: this.value.signed_perawat, penandaTanganId: this.value.perawat_user_id },
        { ditandatangani: this.value.signed_dpjp, penandaTanganId: this.value.dpjp_user_id }
      ],
      userModule.user.id
    );
  }
  get canSignPerawat() { return this.value && !userModule.isMedis; }
  get canSignDpjp() { return userModule.isMedis; }

  recomputeUsiaSaatMenikah() {
    if (!this.form.tanggal_pernikahan) return;
    const tglLahirStr = storePasien.identitasPasien?.tgl_lahir;
    if (!tglLahirStr) return;
    // Format tgl_lahir = 'DD-MM-YYYY' dari API Pasien Eloquent accessor
    const parts = String(tglLahirStr).split("-");
    if (parts.length !== 3) return;
    const dob = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    const tglMenikah = new Date(this.form.tanggal_pernikahan);
    const diffMs = tglMenikah.getTime() - dob.getTime();
    const years = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365.25));
    if (years > 0 && years < 100) this.form.usia_saat_menikah = years;
  }

  autoComputeF() {
    const map: Record<string, number> = {
      "Sepupu derajat 1": 0.0625,
      "Sepupu derajat 2": 0.0156,
      "Paman-keponakan": 0.125,
      "Lainnya": 0
    };
    if (this.form.konsanguinitas_derajat) {
      this.konsangForm.F = map[this.form.konsanguinitas_derajat] || null;
    }
  }

  mounted() {
    this.examinedAt = localISO().slice(0, 16);
  }

  buildPayload() {
    const f = this.form;
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateuser.unit_id,
      status_kmk: f.status_kmk,
      tanggal_pernyataan_status: f.tanggal_pernyataan_status || null,
      sumber_verifikasi_status: f.sumber_verifikasi_status,
      status_faktual: f.status_faktual,
      tanggal_pernikahan: f.tanggal_pernikahan || null,
      usia_saat_menikah: f.usia_saat_menikah,
      pernikahan_ke: f.pernikahan_ke,
      section_detail: this.detailForm,
      section_pasangan: this.showPasangan ? this.pasanganForm : null,
      section_riwayat_sebelumnya: this.showRiwayatPrev ? this.riwayatPrev : null,
      konsanguinitas_ada: f.konsanguinitas_ada,
      konsanguinitas_derajat: f.konsanguinitas_derajat,
      section_konsanguinitas: f.konsanguinitas_ada ? this.konsangForm : null,
      section_reproduksi: this.reproForm,
      section_kb: this.kbForm,
      section_psikososial: this.psikoForm,
      kdrt_wawancara_pribadi: f.kdrt_wawancara_pribadi,
      kdrt_instrumen: f.kdrt_instrumen,
      kdrt_skor_total: f.kdrt_skor_total,
      kdrt_interpretasi: f.kdrt_interpretasi,
      kdrt_aman_di_rumah: f.kdrt_aman_di_rumah,
      section_kdrt: f.kdrt_wawancara_pribadi ? this.kdrtForm : null,
      ringkasan: f.ringkasan,
      section_kesan: this.kesanForm,
      pemicu: f.pemicu,
      examined_at: this.examinedAt ? this.examinedAt.replace("T", " ") + ":00" : null
    };
  }

  enterEdit() {
    this.editMode = true;
    this.editId = this.value.id;
    this.examinedAt = (this.value.examined_at || "").replace(" ", "T").slice(0, 16);
    Object.assign(this.form, this.value, {
      konsanguinitas_ada: this.value.konsanguinitas_ada
    });
    if (this.value.section_detail) Object.assign(this.detailForm, this.value.section_detail);
    if (this.value.section_pasangan) Object.assign(this.pasanganForm, this.value.section_pasangan);
    if (this.value.section_riwayat_sebelumnya) this.riwayatPrev = [...this.value.section_riwayat_sebelumnya];
    if (this.value.section_konsanguinitas) Object.assign(this.konsangForm, this.value.section_konsanguinitas);
    if (this.value.section_reproduksi) Object.assign(this.reproForm, this.value.section_reproduksi);
    if (this.value.section_kb) Object.assign(this.kbForm, this.value.section_kb);
    if (this.value.section_psikososial) Object.assign(this.psikoForm, this.value.section_psikososial);
    if (this.value.section_kdrt) Object.assign(this.kdrtForm, this.value.section_kdrt);
    if (this.value.section_kesan) Object.assign(this.kesanForm, this.value.section_kesan);
  }

  cancelEdit() {
    this.editMode = false;
    this.editId = null;
  }

  addRiwayatPrev() {
    this.riwayatPrev.push({ urutan: this.riwayatPrev.length + 1, tgl_mulai: null, tgl_berakhir: null, sebab_berakhir: null, anak_hidup: 0, anak_meninggal: 0 });
  }

  async save() {
    if (this.readOnly) return;
    if (!(this.$refs.form as any).validate()) return;
    if (this.form.status_kmk === null || this.form.status_kmk === undefined) {
      appModule.sendErrorNotice("Status Pernikahan wajib dipilih (KMK 1423/2022).");
      return;
    }
    this.saving = true;
    try {
      const payload = this.buildPayload();
      if (this.editMode && this.editId) {
        await Service.update(this.editId, payload);
        appModule.sendSuccessNotice("Perubahan disimpan.");
      } else {
        await Service.create(payload);
        appModule.sendSuccessNotice("Form Riwayat Perkawinan tersimpan.");
      }
      this.editMode = false;
      this.editId = null;
      await Store.getByRegister(this.register);
      this.$emit("saved");
    } finally {
      this.saving = false;
    }
  }

  async deleteData() {
    if (!this.bisaHapus) return;
    if (!confirm("Hapus form Riwayat Perkawinan untuk register ini?")) return;
    await Service.destroy(this.value.id);
    await Store.getByRegister(this.register);
    this.$emit("saved");
  }

  printPdf() {
    if (this.value) Service.print(this.value.id);
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(payload: any) {
    if (!this.value) return;
    if (this.signRole === "perawat") {
      await Service.signPerawat(this.value.id, payload);
    } else if (this.signRole === "dpjp") {
      await Service.signDpjp(this.value.id, payload);
    }
    this.modalTtd = false;
    await Store.getByRegister(this.register);
    this.$emit("saved");
  }
}
